import { useState } from 'react';
import { createCheckoutSession } from '../api';

export default function PricingModal({ onClose, reason = '' }) {
  const [loading, setLoading] = useState(null);

  async function handleUpgrade(interval) {
    setLoading(interval);
    try {
      const { url } = await createCheckoutSession(interval);
      window.location.href = url; // redirect to Stripe checkout
    } catch (e) {
      alert('Could not start checkout. Please try again.');
      setLoading(null);
    }
  }

  const glass = {
    background:           'rgba(255,255,255,0.07)',
    backdropFilter:       'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border:               '1px solid rgba(255,255,255,0.12)',
    borderRadius:         20,
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100,
      background: 'rgba(0,0,0,0.7)',
      backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: 16,
    }}>
      <div style={{ ...glass, padding: 28, maxWidth: 420,
        width: '100%', position: 'relative' }}>

        {/* Close button */}
        <button onClick={onClose} style={{
          position: 'absolute', top: 16, right: 16,
          background: 'none', border: 'none',
          color: 'rgba(255,255,255,0.4)', fontSize: 20,
          cursor: 'pointer', padding: 4,
        }}>✕</button>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>⭐</div>
          <h2 style={{
            margin: '0 0 8px', fontSize: 22, fontWeight: 800,
            background: 'linear-gradient(135deg, #fff, #a0c4ff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            Upgrade to Pro
          </h2>
          {reason && (
            <p style={{ fontSize: 14, color: '#fbbf24', margin: 0 }}>
              {reason}
            </p>
          )}
        </div>

        {/* Features */}
        <div style={{ marginBottom: 24 }}>
          {[
            '🤖 Unlimited AI food lookups',
            '📷 Photo meal logging',
            '✨ Weekly AI nutrition insights',
            '💡 AI meal suggestions',
            '📊 Extended nutrients tracking',
            '🏋️ BMI + TDEE suggestions',
            '🔔 Missed meal notifications',
            '📤 Export data as CSV',
          ].map((f, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '6px 0',
              borderBottom: i < 7
                ? '1px solid rgba(255,255,255,0.06)' : 'none',
            }}>
              <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)' }}>
                {f}
              </span>
            </div>
          ))}
        </div>

        {/* Pricing options */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

          {/* Monthly */}
          <button onClick={() => handleUpgrade('month')}
            disabled={loading !== null}
            style={{
              padding: '14px 20px', borderRadius: 12, border: 'none',
              background: loading === 'month'
                ? 'rgba(255,255,255,0.1)'
                : 'linear-gradient(135deg, #5282ff, #a855f7)',
              color: '#fff', fontSize: 15, fontWeight: 700,
              cursor: 'pointer', transition: 'all 0.2s',
              boxShadow: loading === 'month'
                ? 'none' : '0 4px 20px rgba(82,130,255,0.35)',
            }}>
            {loading === 'month'
              ? 'Redirecting to Stripe...'
              : '🚀 Monthly — $1.99 CAD / month'}
          </button>

          {/* Yearly — highlighted as best value */}
          <button onClick={() => handleUpgrade('year')}
            disabled={loading !== null}
            style={{
              padding: '14px 20px', borderRadius: 12,
              border: '2px solid #fbbf24',
              background: loading === 'year'
                ? 'rgba(255,255,255,0.1)'
                : 'rgba(251,191,36,0.12)',
              color: '#fbbf24', fontSize: 15, fontWeight: 700,
              cursor: 'pointer', transition: 'all 0.2s',
              position: 'relative',
            }}>
            {loading === 'year'
              ? 'Redirecting to Stripe...'
              : '⭐ Yearly — $19.99 CAD / year'}
            <span style={{
              position: 'absolute', top: -10, right: 12,
              background: '#fbbf24', color: '#1a1a2e',
              fontSize: 10, fontWeight: 800, padding: '2px 8px',
              borderRadius: 999,
            }}>
              SAVE 16%
            </span>
          </button>

          {/* Continue free */}
          <button onClick={onClose} style={{
            padding: '10px', borderRadius: 12, border: 'none',
            background: 'none', color: 'rgba(255,255,255,0.3)',
            fontSize: 13, cursor: 'pointer',
          }}>
            Continue with free plan
          </button>
        </div>

        <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)',
          textAlign: 'center', marginTop: 16, marginBottom: 0 }}>
          Powered by Stripe · Cancel anytime · Secure payment
        </p>
      </div>
    </div>
  );
}